module.exports = __webpack_public_path__ + "fcedaa096511c3933fa249b53c03d335.MP3";